<template>
    <div class="view view-reset-password">
        <div class="header">
            <h2 class="header__heading">Şifre Sıfırlama</h2>
            <button
                class="btn-login"
                @click="routeLogin">
                <svg class="btn-login__icon" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_18_90)" stroke="#323232" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11.7 13H1.3M7.8 16.9l3.787-3.787a.16.16 0 000-.226L7.8 9.1"/><path d="M7.8 3.9v-.65A1.95 1.95 0 019.75 1.3H22.1a2.6 2.6 0 012.6 2.6v18.2a2.6 2.6 0 01-2.6 2.6H9.75a1.95 1.95 0 01-1.95-1.95v-.65"/></g><defs><clipPath id="clip0_18_90"><path fill="#fff" transform="matrix(-1 0 0 1 26 0)" d="M0 0h26v26H0z"/></clipPath></defs></svg>
            </button>
        </div>
        <div class="profile">
            <div class="profile-image">
                <img class="profile-image__img" width="64" height="64" :src="userImageLink">
                <svg class="profile-image__art-bg" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="100" rx="36" fill="#C0CFE4" fill-opacity=".6"/><rect x="4" y="4" width="92" height="92" rx="35" stroke="#fff" stroke-width="2"/></svg>
            </div>
            <p class="profile__username">{{ $route.query.username }}</p>
            <p class="profile__email">{{ $route.query.email }}</p>
        </div>
        <FormPasswordReset />
    </div>
</template>
<script>
    import FormPasswordReset from '@/components/FormPasswordReset.vue';
    export default {
        components: {
            FormPasswordReset
        },

        computed: {
            userImageLink(){
                return this.$store.state.api.getImage + this.$route.query.id;
            }
        },

        methods: {
            routeLogin(){
                this.$router.push('/login');
            }
        }
    };
</script>
<style scoped src="@/css/views/view-reset-password.css"></style>